import { ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list as getChecklistList } from '@/services/api/resources/checklist';
import { sequence } from '@/ui/helpers';
import { ChecklistQuery } from '@/services/api/resources/checklist/query';

export const useChecklistCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const checkQuery = (): ChecklistQuery => ({
    search: '',
    category: [],
    sort: '',
    dir: '',
    page: 1,
    perPage: 1,
    status: null,
  });

  const performCheck = useTask(
    () => sequence(
      getChecklistList(checkQuery()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
